const LANGUAGE_CODES = {
  'American English': 'en',
  'British English': 'en',
  'French': 'fr',
  'Italian': 'it',
  'Spanish': 'es',
  'Brazilian Portuguese': 'pt',
  'German': 'de',
  'Dutch': 'nl',
  'Russian': 'ru',
  'Polish': 'pl',
  'Danish': 'da',
  'Chinese': 'zh',
  'Portuguese': 'pt',
  'Turkish': 'tr',
  'Greek': 'el',
  'Japanese': 'ja',
  'Moldavan': 'ro',
  'Korean': 'ko',
  'Hindi': 'hi',
  'Urdu': 'ur',
  'Bahasa Indonesia': 'id',
  'Bengali': 'bn',
  'Modern Standard Arabic': 'ar',
  'Vietnamesian': 'vi'
};

export const getLanguageCode = (languageName) => {
  if (!languageName) return 'en';
  return LANGUAGE_CODES[languageName] || 'en';
};

export default LANGUAGE_CODES;